<template>
  <div class="login">
    <div class="container">
      <div class="login__container">
        <img src="@/assets/logo.svg" alt="" class="logo-ruky">
        <!-- <img src="@/assets/forge.svg" alt="" class="logo-forge"> -->
        <h1>{{ $t("login.title") }}</h1>
        <p>{{ $t("login.organization_selection.description") }}</p>
        

        <label>{{$t('login.organization_selection.organization')}}</label>
        <select v-model="organizationId">
          <option v-for="ja in organizations" :key="ja.organizationId" :value="ja.organizationId">{{ ja.organizationName }}</option>
        </select>

        <button @click="continueToHome" class="button button--blue button--register">{{ $t("login.organization_selection.action") }}</button>
        <!-- <span>{{ $t("login.login-with") }}</span> -->
        <div class="menu-powered-by-forge">
          <a href="https://fondationforge.org/" target="_blank">Powered By Forge</a>
        </div>  
      </div>
    </div>
  </div>
</template> 
<script>
import { useStore } from 'vuex';
import { computed } from '@vue/runtime-core';
import persistentData from '@/plugins/persistentData';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const organizationIdStored = computed(() => store.getters.manageUser_organizationId);
    const { t } = useI18n();

    if(organizationIdStored.value != null && organizationIdStored.value != 0)
    {
        router.push('/job-searches/actives');
        return;
    }
    const organizationId = ref(null);
    const organizations = ref([]); 
    const user = computed(() => store.getters.manageUser_user);
    organizations.value = user.value.organizations;
   
   

    async function continueToHome () {
      if (organizationId.value != null) {
        try {
            persistentData.set('organizationId', organizationId.value);
            store.dispatch('manageUser_active');
            router.push('/job-searches/actives');
        } catch (e) {
          store.dispatch('notifications_create', { text: t(`notifications.${e.response.data}`) });
        }
      }
    }

    if(user.value.organizations.length == 1)
    {
      organizationId.value = user.value.organizations[0].organizationId
      continueToHome();
    }

    return {
      organizationId,
      organizations,
      continueToHome
    }
  }
}
</script>